



































































































import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator';
import { Inject } from '@cds/common';
import VueUeditorWrap from "vue-ueditor-wrap";
import { NuoxiaoerService } from '@/services/nuoxiaoer-service';

@Component({
  components: {
    VueUeditorWrap,
  }
})
export default class ArticleModulePopup extends Vue {
  @Inject(NuoxiaoerService) private nuoxiaoerService!: NuoxiaoerService;

  @Emit('saved') // 父级接收事件名
  private async emitSaved(): Promise<void> {
    // return this.xxxxxx; // 父级接收的值
  }

  @Emit('cancel') // 父级接收事件名
  private async emitClose(): Promise<void> {
    // return this.xxxxxx; // 父级接收的值
  }

  @Prop() private moduleId!: Number;

  @Watch('moduleId', { immediate: true, deep: true })
  public onChangeModuleId(newVal: any, oldVal: any) {
    console.log('moduleId watch', newVal)
    this.buOptions = [];
    this.userGroupOptions = [];
    // 移除fetchBUList和fetchUserGroups调用，改为在详情接口中获取
    const isEdit = !!newVal; // uuid
    this.isEdit = isEdit;
    if (isEdit) {
      this.fetchModuleDetail();
    } else {
      this.form = {
        id: '', // uuid
        moduleType: '', // 模块类型：application-应用, scenarios-业务场景, novartis_video-诺华视界
        openRange: [], // 开放范围
        userGroups: [], // 用户组
        name: '', // 名称
        coverImage: '', // 封面图
        logo: '', // Logo
        sortNumber: 1, // 顺序
        redirectUrl: '', // 跳转地址
        content: '', // 正文
        videoId: '', // 视频ID
        remarks: '', // 备注

        // createdTime: '',
        // updatedTime: '',
        // desc: '',
        // existFolder: false,
        // img: '',
        // link: '',
        // modelCode: '',
        // openScope: '',

        // name: res.name,
        // sortNumber: res.sortNumber,
        // moduleType: res.modelCode, // API返回的modelCode对应前端的moduleType
        // content: res.content || '',
        // videoId: res.videoId || '',
        // // 处理openRange（API返回的是逗号分隔的字符串，需要转为数组）
        // openRange: res.openScope ? res.openScope.split(',') : [],
        // // 处理用户组（从数组中提取groupId）
        // userGroups: res.userGroups ? res.userGroups.map((group: any) => group.groupId) : [],
        // // 根据模块类型处理img和link字段
        // redirectUrl: res.link || ''
        // logo: res.modelCode === 'scenarios' ? res.img || '' : '',
        // coverImage: res.modelCode === 'scenarios' ? res.img || '' : '',
      };
    }
  }


  public isEdit: boolean = false;
  public form: any = {
    moduleType: '', // 模块类型：application-应用, scenarios-业务场景, novartis_video-诺华视界
    openRange: [], // 开放范围
    userGroups: [], // 用户组
    name: '', // 名称
    coverImage: '', // 封面图
    logo: '', // Logo
    sortNumber: 1, // 顺序
    redirectUrl: '', // 跳转地址
    content: '', // 正文
    videoId: '', // 视频ID
    remarks: '', // 备注
  };

  // 表单验证规则
  public rules: any = {
    moduleType: [
      { required: true, message: '请选择', trigger: 'change' }
    ],
    name: [
      { required: true, message: '请输入', trigger: 'blur' }
    ],
    sortNumber: [
      { required: true, message: '请输入', trigger: 'blur' }
    ],
    coverImage: [
      { required: function(this: any) { return this.form.moduleType !== 'scenarios'; }, message: '请上传封面图', trigger: 'change' }
    ],
    logo: [
      { required: function(this: any) { return this.form.moduleType === 'scenarios'; }, message: '请上传Logo', trigger: 'change' }
    ],
    videoId: [
      { required: function(this: any) { return this.form.moduleType === 'novartis_video'; }, message: '请输入视频ID', trigger: 'blur' }
    ],
    redirectUrl: [
      {
        validator: (rule: any, value: string, callback: Function) => {
          if (['application','scenarios'].includes(this.form.moduleType) && !value && !this.form.content) {
            callback(new Error('跳转地址和正文至少填写一项'));
          } else {
            callback();
          }
        },
        trigger: 'blur'
      }
    ],
    content: [
      {
        validator: (rule: any, value: string, callback: Function) => {
          if (['application','scenarios'].includes(this.form.moduleType) && !value && !this.form.redirectUrl) {
            callback(new Error('跳转地址和正文至少填写一项'));
          } else {
            callback();
          }
        },
        trigger: 'blur'
      }
    ],
  };

  // UEditor配置
  public myConfig = {
    // 编辑器不自动被内容撑高
    autoHeightEnabled: false,
    // 初始容器高度
    initialFrameHeight: 500,
    // 初始容器宽度
    initialFrameWidth: '100%',
    // 上传文件接口（这个地址是我为了方便各位体验文件上传功能搭建的临时接口，请勿在生产环境使用！！！）
    serverUrl: '/api/application/ueditor/config',
    // serverUrl: '/api/application/img/upload/imgUpload',
    // UEditor 资源文件的存放路径，如果你使用的是 vue-cli 生成的项目，通常不需要设置该选项，vue-ueditor-wrap 会自动处理常见的情况，如果需要特殊配置，参考下方的常见问题2
    UEDITOR_HOME_URL: '/ueditor/',
    toolbars: [[
      'fullscreen', 'source', '|', 'undo', 'redo', 'bold', 'italic', 'underline', 'fontborder', 'strikethrough', 'superscript', 'subscript',
      'removeformat', 'formatmatch', 'autotypeset', 'blockquote', 'pasteplain', 'forecolor',
      'backcolor', 'insertorderedlist', 'insertunorderedlist', 'selectall', 'cleardoc',
      'fontfamily', 'fontsize', 'simpleupload', 'insertimage', 'emotion', /*'scrawl',*/
      /*'music',*/ 'insertvideo', 'insertaudio', 'attachment', 'map',
      'rowspacingtop', 'rowspacingbottom', 'lineheight', 'link', 'unlink'
    ]],
    'fontfamily': [
      { label: '', name: 'songti', val: '宋体,SimSun' },
      { label: '仿宋', name: 'fangsong', val: '仿宋,FangSong' },
      { label: '仿宋_GB2312', name: 'fangsong', val: '仿宋_GB2312,FangSong' },
      { label: '', name: 'kaiti', val: '楷体,楷体_GB2312, SimKai' },
      { label: '', name: 'yahei', val: '微软雅黑,Microsoft YaHei' },
      { label: '', name: 'heiti', val: '黑体, SimHei' },
      { label: '', name: 'lishu', val: '隶书, SimLi' },
      { label: '', name: 'andaleMono', val: 'andale mono' },
      { label: '', name: 'arial', val: 'arial, helvetica,sans-serif' },
      { label: '', name: 'arialBlack', val: 'arial black,avant garde' },
      { label: '', name: 'comicSansMs', val: 'comic sans ms' },
      { label: '', name: 'impact', val: 'impact,chicago' },
      { label: '', name: 'timesNewRoman', val: 'times new roman' }
    ],
    elementPathEnabled: false, // 是否启用元素路径 默认值：true
    wordCount: false, //是否开启字数统计 默认值：true
    // maximumWords: 300, //允许的最大字符数 默认值：10000
    // wordCountMsg: '当前已输入{#count}个字符, 您还可以输入{#leave}个字符。', // 字数统计提示，默认值：'当前已输入{#count}个字符, 您还可以输入{#leave}个字符。 '   {#count}代表当前字数，{#leave}代表还可以输入多少字符数
  };

  // 开放范围选项 - 从详情接口获取
  public buOptions: any[] = [];

  // 用户组选项 - 从详情接口获取
  public userGroupOptions: any[] = [];

  public get openScopeDisplay(): string {
    // 如果buOptions为空，直接显示原始的openScope字符串
    if (this.buOptions.length === 0 && this.form.openRange.length > 0) {
      return this.form.openRange.join(', ');
    }
    return this.form.openRange.map((value: string) => {
      const option = this.buOptions.find((item: any) => item.value === value);
      return option ? option.label : value;
    }).join(', ');
  }

  public get userGroupsDisplay(): string {
    return this.form.userGroups.map((id: string) => {
      const group = this.userGroupOptions.find((item: any) => item.id === id);
      return group ? group.name : id;
    }).join(', ');
  }

  public async created(): Promise<void> {
  }

  // 获取模块详情
  private async fetchModuleDetail(): Promise<void> {
    try {
      const res = await this.nuoxiaoerService.libraryModuleDetail({ id: this.moduleId });
      if (res) {
        // 设置用户组选项数据
        if (res.userGroups && Array.isArray(res.userGroups)) {
          this.userGroupOptions = res.userGroups.map((group: any) => ({
            id: group.groupId,
            name: group.groupName,
            type: group.groupType
          }));
        }

        // 设置开放范围选项数据
        if (res.openScope) {
          // 将openScope字符串拆分为数组，用于显示
          const openScopeArray = res.openScope.split(',').map((item: string) => item.trim());
          this.buOptions = openScopeArray.map((item: string) => ({
            value: item,
            label: item
          }));
        }

        // 处理数据映射
        this.form = {
          ...this.form, // 保留默认值
          id: res.id,
          name: res.name,
          sortNumber: res.sortNumber,
          moduleType: res.modelCode, // API返回的modelCode对应前端的moduleType
          content: res.content || '',
          videoId: res.videoId || '',
          remarks: res.remarks || '',
          userNames: res.userNames?res.userNames.join(',') :'',

          // 处理openRange（API返回的是逗号分隔的字符串，需要转为数组）
          openRange: res.openScope ? res.openScope.split(',').map((item: string) => item.trim()) : [],

          // 处理用户组（从数组中提取groupId）
          userGroups: res.userGroups ? res.userGroups.map((group: any) => group.groupId) : [],

          // 根据模块类型处理img和link字段
          redirectUrl: res.link || ''
        };

        // 根据模块类型判断图片字段应该赋值给哪个属性
        if (res.modelCode === 'scenarios') {
          this.form.logo = res.img || '';
        } else {
          this.form.coverImage = res.img || '';
        }

        console.log('映射后的表单数据:', this.form);
      }
    } catch (error) {
      console.error('获取模块详情失败：', error);
      this.$message.error('获取模块详情失败，请刷新重试');
    }
  }

  // 模块类型变更
  public moduleTypeChanged(val: string): void {
    // 根据模块类型重置表单某些字段
    this.form.coverImage = '';
    this.form.logo = '';
    this.form.redirectUrl = '';
    this.form.content = '';
    this.form.videoId = '';

    // 触发表单验证
    this.$nextTick(() => {
      (this.$refs.form as any).validateField(['coverImage', 'logo', 'redirectUrl', 'content', 'videoId']);
    });
  }

  // 通用图片上传方法
  private customImageUpload(file: any, fieldName: string, formItem: string): void {
    const formData = new FormData();
    formData.append('files', file.file);

    const loading = this.$loading({
      text: `上传中...`,
    });

    // 使用API上传图片
    this.nuoxiaoerService.uploadImage(formData).then((res) => {
        console.log(res)
      if (res && res.state=="SUCCESS") {
        this.form[fieldName] = res.url;
        (this.$refs[formItem] as any).validate();
      } else {
        this.$message({
          type: 'error',
          message: '上传失败：' + (res.message || '未知错误')
        });
      }
    }).catch((err) => {
      this.$message({
        type: 'error',
        message: '上传失败：' + (err.message || '未知错误')
      });
    }).finally(() => {
      loading.close();
    });
  }

  // 上传封面图
  private customUploadForCover(file: any): void {
    this.customImageUpload(file, 'coverImage', 'coverImageFormItem');
  }

  // 上传Logo
  private customUploadForLogo(file: any): void {
    this.customImageUpload(file, 'logo', 'logoFormItem');
  }

  // 上传封面图前的检查
  private beforeCoverUpload(file: File): boolean {
    const isImage = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/gif';
    const isLt2M = file.size / 1024 / 1024 < 2;

    if (!isImage) {
      this.$message.error('上传封面只能是图片格式!');
    }
    if (!isLt2M) {
      this.$message.error('上传封面图片大小不能超过 2MB!');
    }

    return isImage && isLt2M;
  }

  // 上传Logo前的检查
  private beforeLogoUpload(file: File): boolean {
    const isImage = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/gif';
    const isLt2M = file.size / 1024 / 1024 < 2;

    if (!isImage) {
      this.$message.error('上传Logo只能是图片格式!');
    }
    if (!isLt2M) {
      this.$message.error('上传Logo图片大小不能超过 2MB!');
    }

    return isImage && isLt2M;
  }

  // 保存表单
  public submitForm(formName: string): void {
    const addRef = (this.$refs.form as any);

    addRef.validate(async (isValid: boolean, invalidFields: object) => {
      if (!isValid) {
        console.log('表单验证失败', invalidFields);
        return false;
      }

      try {
        // 确认保存
        await this.$confirm('是否确认保存并发布？', '提示', {
          confirmButtonText: '是',
          cancelButtonText: '否',
          type: 'info'
        });

        // 根据不同模块类型，处理提交数据
        let submitData: any = {
          id: this.form.id,
          name: this.form.name,
          sortNumber:this.form.sortNumber,
          modelCode: this.form.moduleType, // 使用moduleType作为modelCode
          openScope: this.form.openRange.join(','), // 将数组转换为逗号分隔的字符串
          userGroups: this.form.userGroups.map((groupId: string) => {
            // 查找对应的用户组信息
            const group = this.userGroupOptions.find((item: any) => item.id === groupId);
            return {
              groupId: groupId,
              groupName: group ? group.name : '',
              groupType: group ? group.type : ''  // 如果需要groupType，可以在fetchUserGroups中获取
            };
          }),
          videoId: this.form.videoId || '',
          remarks: this.form.remarks || '',
          content: this.form.content || '' // 添加富文本内容字段
        };

        // 根据模块类型处理图片和链接
        if (this.form.moduleType === 'novartis_video') {
          // 诺华视界用coverImage
          submitData.img = this.form.coverImage || '';
          submitData.link = '';
        } else if (this.form.moduleType === 'application') {
          // 应用模块用coverImage
          submitData.img = this.form.coverImage || '';
          submitData.link = this.form.redirectUrl || '';
        } else if (this.form.moduleType === 'scenarios') {
          // 业务场景用logo
          submitData.img = this.form.logo || '';
          submitData.link = this.form.redirectUrl || '';
        }

        console.log('提交数据:', submitData);

        // 判断是新增还是编辑模式
        if (this.isEdit) {
          // 编辑模式，添加id字段
          // 使用更新接口
          await this.nuoxiaoerService.updateLibraryModule(submitData);
          this.$message({ message: '更新成功', type: 'success' });
        } else {
          // 新增模式
          await this.nuoxiaoerService.saveLibraryModule(submitData);
          this.$message({ message: '保存成功', type: 'success' });
        }
        this.emitSaved();
      } catch (error) {
        if (error === 'cancel') {
          // 用户取消操作，不做处理
          return;
        }
        console.error('保存失败：', error);
        this.$message.error('保存失败：' + (error.message || '未知错误'));
      }
    });
  }

  // 取消按钮
  public async handleCancel(): Promise<void> {
    try {
      await this.$confirm('是否关闭当前界面？关闭后，当前界面内容将会丢失', '提示', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'warning'
      });
      this.emitClose();
    } catch (error) {
      // 用户取消操作，不做处理
    }
  }
}
